import { Alert, Divider, Space, Spin } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const Chart = styled.div`
  margin-top: 10px;

  background: ${COLORS.PRIMARY_GREY_T_98};
  border: 1px solid ${COLORS.GREY_T_80};
  border-radius: 10px;
  overflow: auto;
`
export const ChartElement = styled(Flex)`
  border-right: ${props =>
    props?.borderLast ? `1px solid ${COLORS.GREY_T_80}` : 'none'};
  padding-right: 5px;
  gap: 5px;
`

export const TextHeading = styled.div`
  font-size: ${props => props.size ?? '15px'};
  font-weight: ${props => props.weight ?? '700'};
  color: ${props =>
    props.color ? props.color : props.dark ? '#000000' : '#1a2645'};
  margin-top: ${props => props.mTop ?? 'unset'};
  margin-bottom: ${props => props.mBottom ?? 'unset'};
`

export const SubChart = styled(Flex)`
  padding: 17px;
  gap: 10px;
`
export const Level = styled(Flex)`
  font-size: ${FONT.F_LG};
  color: ${COLORS.GREY_T_60};
  sub {
    font-size: 10px;
    padding-top: 5px;
  }
`
export const Marks = styled.div`
  font-size: ${FONT.F_LG};
  color: ${COLORS.GREY_T_30};
`

export const SkillsText = styled.div`
  margin-top: 8px;
  font-family: 'Plus Jakarta Sans';
  font-size: 14px;
  font-weight: 500;
  font-style: 'normal';
  line-height: 18px;
  color: #999fac;
  margin-bottom: 10px;
`

export const MediumLabel = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #4d566e;
`

export const ParaText = styled.div`
  padding-left: 45px;
  padding-top: 10px;
`
export const QualificationDiv = styled.div`
 
  padding: 10px;
  width: 100%;
  left: 0;
  top: 0;
  position: sticky;
  z-index: 1;
  background-color: #fafafb;
`

export const MulitiSlectbox = styled.div`
  display: flex;
  gap: 2rem;
  ${''}
  margin-bottom: 25px;
`
export const MulitiSelectsboxes = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`

export const DeleteButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65px;
  background: #fafafb;
  border: ${props => (props.border ? props.border : '1px solid #e6e7ea')};
  border-radius: 10px;
  cursor: pointer;
  height: ${props => (props.height ? props.height : '42px')};
`
export const LabelContent = styled.span`
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #999fac;
  margin-top: 10px;
`

export const SkillSetLabel = styled.label`
  display: flex;
  align-items: left;
  flex-direction: column;
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #4d566e;
`

export const NoDataFound = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  font-size: small;
  font-weight: 600;
  border: 1px solid rgb(220, 236, 250);
  margin: 0em 0.5em;
  border-radius: 5px;
  padding: 11.5em 0em;
`

export const StyledDivider = styled(Divider)`
  font-size: smaller !important;
  font-weight: 700 !important;
  border-top-color: black !important;
  transform: none !important;

  &.ant-divider-horizontal.ant-divider-with-text::before,
  &.ant-divider-horizontal.ant-divider-with-text::after {
    position: relative;
    width: 50%;
    border-top: 1px solid transparent;
    border-top-color: inherit;
    border-bottom: 0;
    transform: none !important;
    content: '';
  }
`
export const DividerGap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  font-weight: 550;
  width: 100%;
  padding-left: 1em;
  gap: 0.3em;
`
export const StyledDashedBorderBox = styled.div`
  border: 2px dashed #d6dbf7;
  padding: 20px;
  border-radius: 10px;
  background-color: #f9fafe;
  margin-top: 30px;
  position: relative;
`
export const ButtonRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -38px;
`

export const AndOrStyle = styled.div`
  width: -webkit-fill-available;
`
export const ArrearSubText = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 400;
  line-height: 18px;
  color: #969696;
`

export const MarginDiv = styled.div`
  margin-top: 10px;
`

export const TypeGroup = styled(Flex)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  width: ${props => props.width || '100%'};
  align-items: center;
  justify-content: flex-start;
`
export const FormBottomSpacing = styled.div`
  margin-bottom: 150px;
  padding-bottom: 80px;
`
export const EmptyDivElement = styled.div`
  width: auto;
`

export const StyledDivision = styled.div`
  text-align: center;
  line-height: 1.5;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 11px;
`
export const NumberDiv = styled.div`
  padding-top: 10px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 35px;
`
export const MainDiv = styled.div`
  border: #d8ddff 2px solid;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
`
export const StudentDiv = styled.div`
  font-size: 20px;
`
export const MainQualificationDiv = styled.div`
width: 17%;
position: fixed;
  border: 2px solid rgb(216, 221, 255);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;

  padding-left: 20px;
  padding-right: 20px;

  height: 25em;
  margin-top: 1em;
  overflow-y: auto;
`
export const Chips = styled.div`
  border: 1px solid #3249d7;
  border-radius: 14px;
  font-size: 10px;
  color: #000000;
  padding: 1px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
`

export const TableContainer = styled.div`
  height: 45vh;
  overflow: auto;
  border: 1px solid #e2e2e2;
  box-shadow: 0px 0px 5px 1px #bfd3ff;
  border-radius: 5px;
  margin: 1em 0em;
`

export const StyledTable = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  font-size: 11px;
`

export const StyledThead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 40;
`

export const StyledTh = styled.th`
  background-color: #fff;
  border: 0.1px solid aliceblue;
  padding: 8px;
  text-align: left;
  top: 0;
  z-index: 1;
`

export const StyledTd = styled.td`
  border: 0.5px solid #f0f4ff;
  padding: 8px;
  text-align: left;
`

export const FlexCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const LabelText = styled.span`
  margin-left: -8px;
  font-weight: 600;
  color: ${props => (props.indent ? '#c0c0c0' : 'inherit')};
  font-size: ${props => (props.indent ? 'smaller' : 'inherit')};
`
export const IndentedTd = styled(StyledTd)`
  padding-left: 2.5em;
  color: #c0c0c0;
  font-size: smaller;
`

export const BoxWithButton = styled.div`
  position: relative;
`
export const SectionName = styled.div`
  padding: 20px;
  background: rgba(249, 250, 254, 1);
  border: 1px dashed rgba(214, 219, 247, 1);
  border-radius: 10px;
`
export const CompanyContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => (props?.bottomSpace ? '30px' : '10px')};
  gap: 1rem;

  input,
  select,
  textarea {
    // width: 500px;
    
    margin-top: 10px;
    border: 1px solid rgba(214, 219, 247, 1)
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0px 2px 6px 0px rgba(123, 97, 255, 0.15);
  }
`

export const AddMoreButton = styled.button`
  border: none;
  color: #007bff;
  font-size: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  background: rgba(249, 250, 254, 1);
  bottom: -20px;
  border: 1px dashed rgb(204, 204, 204);
  &:hover {
    color: #0056b3;
  }
  width: 90%;
  left: 5%;
  justify-content: center;
  border-radius: 10px;
  height: 45px;
`
export const AddMoreText = styled.span`
  margin-left: 8px;
  font-size: 16px;
  color: #3249d7;
`
export const DurationLabel = styled.span`
  font-size: 0.875rem; /* 14px */
  font-weight: 500;
  color: #595959; /* neutral gray */
  min-width: 32px; /* prevents label from collapsing */
  text-align: left;
  margin-left: 8px;
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`

export const CtcInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const CtcInputGroup = styled.div`
  flex: ${({ flex }) => flex || 'auto'};
  min-width: 0;
`

export const DashSeparator = styled.div`
  flex: none;
  padding: 0 8px;
  text-align: center;
`

export const OptionWrapper = styled.div`
  // display: flex;
  // align-items: center;
  // width: 100%;
  position: relative;
`

export const OptionError = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 2px;
`

export const TickIconSpan = styled.div`
  display: flex;
  position: absolute;
  right: 5%;
  top: 28%;
  // transform: translateY(-50%);
  cursor: pointer;
  // z-index: 2;
`

export const TimeIcon = styled.div`
  display: flex;
  border-radius: 10px;
  background-color: #e2f5fd;
  align-content: center;
  justify-content: center;
  align-items: center;
  justify-items: center;
  width: 40px;
  height: 40px;
`
export const TimeSpace = styled(Space)`
  padding: 10px;
  background-color: #f3fbfe;
  border-radius: 10px;

  align-content: center;
  border: 1px solid #c5e4fa;
  padding-right: 30px;
`

export const SkillBox = styled.div`
  background: #ebecee;

  padding: 3px 8px 3px 8px;
  border-radius: 6px;
  color: #010e30;
  font-size: 14px;
  font-weight: 500;
`

export const Condition = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #010e30;
  text-align: 'center';
`
export const TextWithIcon = styled.div`
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? '' : 'center')};

  gap: ${({ gap }) => gap ?? '1rem'};
  width: ${({ width }) => width ?? ''};
  justify-content: ${({ justify }) => justify ?? 'start'};
  flex-direction: ${({ direction }) => direction ?? 'row'};
  flex-wrap: ${props => props.wrap ?? 'nowrap'};
`
export const ShowDiv = styled.div`
  /* font-size: 15px;
 color: blue;
 text-align: left; */
  color: rgb(50, 73, 215);
  font-weight: bold;
  cursor: pointer;
`

export const ULElement = styled.ul`
  padding-left: 25px;
`

export const LIElement = styled.li`
  color: ${({ color }) => (color ? '#000000' : COLORS.GREY_T_50)};
  font-size: ${({ fontSize }) => fontSize ?? '15px'};
  font-weight: ${({ fontWeight }) => fontWeight ?? 400};
  padding-bottom: 2px;
  ::marker {
    color: ${({ color }) => (color ? '#000000' : COLORS.GREY_T_50)};
  }
`
export const EditorContent = styled.span`
  padding: 20px 0;
  word-break: break-all;
  * {
    line-height: 188%;
    color: ${COLORS.GREY_T_50_2} !important;
  }
  p,
  ul,
  ol {
    margin-bottom: 10px;
  }
  li {
    line-height: 25px;
  }
`
export const StyledCardDiv = styled(Flex)`
  padding: 12px;
  justify-content: space-between;
  align-items: center;

  height: ${props => (props?.height ? props.height : '63px')};
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  width: 32%;  /* or 33%, you can adjust */
  max-width: 415px; /* same as your date/time cards */
`
export const FormSpinner = styled(Spin)`
  height: 72vh;
  width: 100%;
  align-content: center;
`